import {
    Component,
    ElementRef,
    NgZone,
    ViewChild,
    Inject,
    Optional,
    OnInit,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RoleService } from "app/main/services/roles.service";
import { TranslateService } from "@ngx-translate/core";

import {
    MatAutocompleteSelectedEvent,
    MatAutocomplete,
} from "@angular/material/autocomplete";
import { map, startWith } from "rxjs/operators";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { SujetoObligado } from "app/main/models/sujeto-obligado.model";
import { TipoSujetoObligado } from "app/main/models/tipo-sujeto-obligado.model";
import { TipoDocumentoService } from "app/main/services/tipo-documento.service";
import { TipoSujetoObligadoService } from "app/main/services/tipo-sujeto-obligado.service";
import { TipoDocumento } from "app/main/models/tipo-documento.model";
import { PaisService } from "app/main/services/pais.service";
import { SectorActividadService } from "app/main/services/sector-actividad.service";
import { Direccion } from "app/main/models/direccion.model";
import { Telefono } from "app/main/models/telefono.model";
import { SujetoObligadoService } from "app/main/services/sujeto-obligado.service";

@Component({
    selector: "sujeto-obligado-dialog-box",
    templateUrl: "./sujeto-obligado-dialog-box.component.html",
    styleUrls: ["./sujeto-obligado-dialog-box.component.scss"],
})
export class SujetoObligadoDialogBoxComponent {
    displayedColumnsEvaluaciones: string[] = [
        "nombre",
        "estado",
        "version",
        "estructuraJerarquica",
        "creador",
        "dueno",
        "fechaInicio",
        "fechaFin",
    ];

    action: string;
    LOCAL_DATA: any;
    razonSocialPais: any;
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    tiposDocumentos = [];
    tiposSujetos = [];
    tiposSectorIndustrial = [];
    paises = [];
    displayedColumns: string[] = ["estructura", "nombre"];

    constructor(
        private roleService: RoleService,
        public dialogRef: MatDialogRef<SujetoObligadoDialogBoxComponent>,
        public translate: TranslateService,
        private serviceTipoSujetoObligado: TipoSujetoObligadoService,
        private serviceTipoDocumento: TipoDocumentoService,
        private servicePais: PaisService,
        private sujetosObligadosService: SujetoObligadoService,
        private serviceSectorIndustrial: SectorActividadService,
        // @Optional() is used to prevent error if no data is passed
        @Optional() @Inject(MAT_DIALOG_DATA) public data: SujetoObligado
    ) {
        console.log(data);
        this.LOCAL_DATA = { ...data };
        this.action = this.LOCAL_DATA.action;
        delete this.LOCAL_DATA["action"];
        if (
            this.LOCAL_DATA == null ||
            Object.keys(this.LOCAL_DATA).length == 0
        ) {
            this.LOCAL_DATA = new SujetoObligado({});
        }

        if (this.action == "Update") {
            //Se busca el sujeto obligado de la base de datos por el id
            this.sujetosObligadosService
                .get(this.LOCAL_DATA.id)
                .subscribe((req) => {
                    this.LOCAL_DATA = req.body;

                    var correoElectronico =
                        this.LOCAL_DATA.contacto.correoElectronico;

                    delete this.LOCAL_DATA.contacto["correoElectronico"];

                    var direccionFiscal =
                        this.LOCAL_DATA.contacto != null &&
                        this.LOCAL_DATA.contacto.direcciones != null
                            ? this.LOCAL_DATA.contacto.direcciones.find(
                                  (direccion) => direccion.tipo == "FISCAL"
                              )
                            : new Direccion({});

                    var direccionFisica =
                        this.LOCAL_DATA.contacto != null &&
                        this.LOCAL_DATA.contacto.direcciones != null
                            ? this.LOCAL_DATA.contacto.direcciones.find(
                                  (direccion) => direccion.tipo == "FISICA"
                              )
                            : new Direccion({});

                    delete this.LOCAL_DATA.contacto["direcciones"];

                    var telefono =
                        this.LOCAL_DATA.contacto.telefonos != null &&
                        this.LOCAL_DATA.contacto.telefonos.length > 0
                            ? this.LOCAL_DATA.contacto.telefonos[0]
                            : null;

                    delete this.LOCAL_DATA.contacto["telefonos"];

                    delete this.LOCAL_DATA["contacto"];

                    this.LOCAL_DATA = {
                        ...this.LOCAL_DATA,
                        correoElectronico: {
                            correo: correoElectronico || "",
                        },
                        telefono: telefono || new Telefono({}),
                        direccionFisica: direccionFisica || new Direccion({}),
                        direccionFiscal: direccionFiscal || new Direccion({}),
                        razonSocialPais:
                            this.LOCAL_DATA.razonSocial?.tipo?.pais || null,

                        razonSocial: this.LOCAL_DATA.razonSocial || null,
                    };

                    this.razonSocialPais = this.paises.find(
                        (pais) => pais.id == this.LOCAL_DATA.razonSocialPais.id
                    );

                    if (this.LOCAL_DATA.razonSocial != null) {
                        if (
                            this.LOCAL_DATA.razonSocial.fechaExpedicion != null
                        ) {
                            this.LOCAL_DATA.razonSocial.fechaExpedicion =
                                new Date(
                                    this.LOCAL_DATA.razonSocial.fechaExpedicion
                                );
                        }
                        if (
                            this.LOCAL_DATA.razonSocial.fechaVencimiento != null
                        ) {
                            this.LOCAL_DATA.razonSocial.fechaVencimiento =
                                new Date(
                                    this.LOCAL_DATA.razonSocial.fechaVencimiento
                                );
                        }
                    }

                    if (this.razonSocialPais != null) this.loadDocumentsTypes();
                });
        }
    }

    @ViewChild("usuarioInput") usuarioInput: ElementRef<HTMLInputElement>;
    @ViewChild("auto") matAutocomplete: MatAutocomplete;

    doAction(): void {
        console.log("im here");
        this.dialogRef.close({ event: this.action, data: this.LOCAL_DATA });
    }

    closeDialog(): void {
        this.dialogRef.close({ event: "Cancel" });
    }

    onTipoSujetoObligadoChange(event: any): void {
        this.loadDocumentsTypes();
    }

    ngOnInit(): void {
        this.serviceTipoSujetoObligado
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposSujetos = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                        tipo: tipo.tipo,
                        nombreC: tipo.tipo
                            .toLowerCase()
                            .replace("_", " ")
                            .split(" ")
                            .map(
                                (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                            )
                            .join(" "),
                    };
                });
            });

        this.servicePais
            .getList()
            .pipe()
            .subscribe((req) => {
                this.paises = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });

                if (this.LOCAL_DATA.razonSocialPais != null) {
                    this.razonSocialPais = this.paises.find(
                        (pais) => pais.id == this.LOCAL_DATA.razonSocialPais.id
                    );
                    this.loadDocumentsTypes();
                }
            });

        this.serviceSectorIndustrial
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposSectorIndustrial = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });
            });
    }

    loadDocumentsTypes() {
        this.tiposDocumentos = [];
        if (this.razonSocialPais != null)
            this.serviceTipoDocumento
                .getByCountryAndTypeList(
                    this.razonSocialPais.id,
                    this.LOCAL_DATA.tipoSujetoObligado.tipo
                )
                .pipe()
                .subscribe((req) => {
                    this.tiposDocumentos = req.body.map((tipo) => {
                        console.log(tipo);
                        return {
                            id: tipo.id,
                            nombre: tipo.nombre,
                            tipo: tipo.tipo,
                        };
                    });

                    //this.razonSocialPais.documentos = this.tiposDocumentos;
                });
    }

    setLocal(option): void {
        this.LOCAL_DATA.id = option.id;
    }

    compareObjects(o1: any, o2: any): boolean {
        var equals = false;
        if (
            o1 != null &&
            o2 != null &&
            typeof o1 === "object" &&
            typeof o2 === "object" &&
            "id" in o1 &&
            "id" in o2 &&
            o1.id === o2.id
        ) {
            equals = true;
        } else {
            equals = o1 == o2 ? true : false;
        }

        return equals;
    }

    openDialog(): void {}
}
